import { useEffect } from "react";

/**
 * Marca `<body class="keyboard-open">` mientras el teclado del móvil está
 * abierto, para que la barra flotante de abajo (y cualquier cosa anclada al
 * fondo) se aparte en vez de quedarse flotando ENCIMA del teclado — que es lo
 * que ninguna app nativa hace.
 *
 * Cómo se detecta: el teclado no dispara ningún evento propio, pero encoge el
 * `visualViewport` sin tocar `innerHeight`. Si la diferencia pasa de 150 px es
 * teclado (una barra de navegador que se retrae ronda los 60-90 px).
 *
 * Se monta una sola vez, en la raíz de la app.
 */
const KEYBOARD_MIN_PX = 150;

export function useKeyboardOpenClass() {
  useEffect(() => {
    const vv = typeof window !== "undefined" ? window.visualViewport : undefined;
    if (!vv) return;

    let raf = 0;
    const sync = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const hidden = window.innerHeight - vv.height;
        document.body.classList.toggle("keyboard-open", hidden > KEYBOARD_MIN_PX);
      });
    };

    sync();
    vv.addEventListener("resize", sync);
    vv.addEventListener("scroll", sync);
    return () => {
      cancelAnimationFrame(raf);
      vv.removeEventListener("resize", sync);
      vv.removeEventListener("scroll", sync);
      document.body.classList.remove("keyboard-open");
    };
  }, []);
}
